import { useMemo } from 'react';
import { INTERAGENCY_CHAT } from '@rsos/capstone/src/constants/capabilities';
import { INTERAGENCY_CHAT_PERMISSION } from '@rsos/constants/permissions';
import useHasCapability from './useHasCapability';
import useHasPermission from './useHasPermission';

/**
 * Interagency Chat access requires both the agency-level `interagency_chat`
 * capability and the per-user `INTERAGENCY_CHAT` permission. The capability
 * makes the feature available to the authority; the permission lets admins
 * control which roles within that authority can use it.
 */
const useIsInteragencyChatEnabled = (): boolean => {
  const { hasCapability } = useHasCapability(INTERAGENCY_CHAT);
  const { hasPermission } = useHasPermission(INTERAGENCY_CHAT_PERMISSION);

  const isInteragencyChatEnabled = useMemo(() => {
    return Boolean(hasCapability) && Boolean(hasPermission);
  }, [hasCapability, hasPermission]);

  return isInteragencyChatEnabled;
};

export default useIsInteragencyChatEnabled;
